import { render, staticRenderFns } from "./sportbook-matche-archived.vue?vue&type=template&id=3d5b86c9&scoped=true&"
import script from "./sportbook-matche-archived.vue?vue&type=script&lang=js&"
export * from "./sportbook-matche-archived.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-matche-archived.vue?vue&type=style&index=0&id=3d5b86c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b86c9",
  null
  
)

export default component.exports